var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRandom = function SvgRandom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.333 13.417a7.4 7.4 0 0 0 1.334 1.834C6.083 16.667 7.917 17.5 10 17.5c1.917 0 3.667-.75 5-1.917a7.12 7.12 0 0 0 2.417-4.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.417 13.416H3.333v4.083m13.25-10.916A7.4 7.4 0 0 0 15.25 4.75C13.917 3.333 12 2.5 9.917 2.5c-1.917 0-3.667.75-5 1.917-1.334 1.25-2.25 2.916-2.417 4.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.583 6.583h4.084V2.5"
  })));
};
export default SvgRandom;